import { render, staticRenderFns } from "./InteractiveTextDesigner.vue?vue&type=template&id=720b01cc"
import script from "./InteractiveTextDesigner.vue?vue&type=script&lang=js"
export * from "./InteractiveTextDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports